
import { printf, toFail, split, substring, concat, toText, interpolate } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { FastSimulation__get_SimulatedTopSheet } from "../Simulator/SimTypes.js";
import { getFastSim } from "../Simulator/Simulator.js";
import { FSharpMap__get_Keys, add as add_1, map as map_1, FSharpMap__get_Item, tryFind as tryFind_1, FSharpMap__get_Count } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { zip, tail, head, forAll, append, contains as contains_1, fold, map, exists, filter, tryHead, cons, isEmpty, tryFind, empty, ofArray, singleton, tryItem, length } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { value as value_25, some, flatten, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { currentSheetIsOutOfDate as currentSheetIsOutOfDate_1, drawBlockModelToUserData, userDataToDrawBlockModel, openSheetIsReadOnly, mapOverProject, getWSModel, Constants_multipliers } from "./ModelHelpers.js";
import { safeHash, curry2, createAtom, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { MouseOp } from "../Common/DrawHelpers.js";
import { enabled } from "../Shared/Log.js";
import { cropToLength, sprintInitial } from "../Common/Helpers.js";
import { getTimeMs } from "../Common/TimeHelpers.js";
import { error, warn, dbg, countMessage } from "../Shared/Log.js";
import { DragAddition, pendingDragAddition_, popupDialogData_, paramCompSpec_, int_, text_, UserData_$reflection, Model, UserData as UserData_2, SimSubTab, simSubTabVisible_, WaveSimModel, selectedComponent_, RightTab, rightPaneTabVisible_, sheet_, uISheetTrail_, openedLibrarySheets_, Msg, WaveSimState } from "../Model/ModelType.js";
import { updateAllMemoryComps } from "./MemoryEditorView.js";
import { Color_IColor, Common_GenericOption, Modifier_IModifier, TextWeight_Option, Text_div } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { columns } from "../fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { column } from "../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Block_div, heading, Option, panel } from "../fable_modules/Fulma.3.0.0/Components/Panel.fs.js";
import { Option as Option_1, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { choicePopup, openInBrowser } from "../DrawBlock/PopupHelpers.js";
import * as react from "react";
import { writeFile, tryReadFileSync, openFolderInFileManager, pathJoin } from "../Interface/FilesIO.js";
import { verilogOutputForSheet } from "./SimulationView.js";
import { VMode } from "../VerilogComponent/Verilog.js";
import { toString, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { DrawModelType_SheetT_zoom_, DrawModelType_BusWireT_segments_, DrawModelType_SheetT_wireOf_, DrawModelType_BusWireT_mode_, DrawModelType_SymbolT_Model, DrawModelType_BusWireT_symbol_, DrawModelType_SheetT_wire_, DrawModelType_SheetT_KeyboardMsg, DrawModelType_SheetT_symbolEdit_, DrawModelType_SheetT_selectedWires_, DrawModelType_SheetT_selectedComponents_, DrawModelType_BusWireT_Msg, DrawModelType_SymbolT_Msg, DrawModelType_SheetT_SymbolEditMode, DrawModelType_SheetT_Msg, DrawModelType_BusWireT_ASegment_$reflection, DrawModelType_BusWireT_Wire_$reflection, DrawModelType_SymbolT_Symbol_$reflection } from "../Model/DrawModelType.js";
import { Component, ComponentType, Memory1, Project, LoadedComponent, JSDiagramMsg, Rotation, XYPos_$reflection, CustomComponentType_$reflection } from "../Common/CommonTypes.js";
import { union_type, bool_type, string_type, list_type, int32_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { saveOpenProjectInNewFormat, saveOpenFileActionWithModelUpdate, tidyRecents, setTopSheetState, deleteFileConfirmationPopup, openFileInProject, getFileInProject, getSheetTrees, SheetTree_$reflection } from "./MenuHelpers.js";
import { isLibrarySheet, ComponentLibrary_$reflection } from "../Interface/ComponentLibraries.js";
import { getDrawBlockPos } from "../DrawBlock/SheetDisplay.js";
import { getHeaderHeight } from "./Style.js";
import { Constants_zoomIncrement, Constants_maxMagnification, mouseOn } from "../DrawBlock/Sheet.js";
import { StringModule_Length, StringModule_StartsWith } from "../Common/EEExtensions.js";
import { item as item_13 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { getClickedSegment } from "../DrawBlock/BusWireUpdateHelpers.js";
import { wireWaveToOffer, compWavesToOffer } from "./WaveSim/WaveSimSelect.js";
import { remove, add, contains } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { topSheetChoiceMatters } from "../Common/ParameterAnalysis.js";
import { debugLevel } from "../Interface/JSHelpers.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Optic_Map, Optic_Map_op_HatPercent_Z1462312A } from "../Common/Optics.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { addFileToProject, changeSubtreeLockState, LockState, changeLockState, renameFileInProject } from "./TopMenuView.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { exportLibrary, saveAsLibraryComponent, duplicateSheet } from "./MiscMenuView.js";
import { errorFilesNotification, successNotification } from "./Notifications.js";
import { Compose_Lens_op_GreaterMinusGreater_Z15C92E89 as Compose_Lens_op_GreaterMinusGreater_Z15C92E89_1, Optic_Map_op_HatPercent_Z1462312A as Optic_Map_op_HatPercent_Z1462312A_1, Optic_Set_op_HatEquals_Z147477F8 as Optic_Set_op_HatEquals_Z147477F8_1 } from "../Common/Optics.js";
import { DrawModelType_SymbolT_appearance_, DrawModelType_SymbolT_opacity_, DrawModelType_SymbolT_colour_, DrawModelType_SymbolT_moving_ } from "../Model/DrawModelType.js";
import { getSymbolColour } from "../DrawBlock/Symbol.js";
import { updateWireSegmentJumpsAndSeparations, separateAndOrderModelSegments } from "../DrawBlock/BusWireSeparate.js";
import { min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { viewWaveInfoPopup } from "./UIPopups.js";
import { viewLibraryItem, hideLibraryItem } from "../Shared/ContextMenus.js";
import { Result_MapError, FSharpResult$2, Result_Bind } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { Convert_serialize, Convert_fromJson } from "../Common/SimpleJson/Json.Converter.js";
import { SimpleJson_parseNative } from "../Common/SimpleJson/SimpleJson.js";
import { createTypeInfo } from "../Common/SimpleJson/TypeInfo.Converter.js";
import { doActionWithSaveFileDialog } from "./FileUpdate.js";
import { now, minValue } from "../fable_modules/fable-library-js.5.13.0/Date.js";
import { update as update_1 } from "../DrawBlock/SheetUpdate.js";
import { getCopiedSymbols } from "../DrawBlock/BlockHelpers.js";
import { copyParamSlotsToPastedComponents } from "./ParameterView.js";

export const Constants_memoryUpdateCheckTime = 500;

export const Constants_copiedPathNotificationTime = 2500;

/**
 * Used to filter specific mouse messages based on mouse data.
 */
export function matchMouseMsg(msgSelect, msg) {
    if (msg.tag === 3) {
        const sMsg = msg.fields[0];
        if (sMsg.tag === 8) {
            return msgSelect(sMsg.fields[1]);
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

/**
 * short summary used where Sheet messages are too complex to print
 */
export function shortDSheetMsg(sMsg) {
    if (sMsg.tag === 8) {
        return `Mouse ${sMsg.fields[1]}`;
    }
    else {
        return `Sheet ${interpolate("%10A%P()", [sMsg])}`;
    }
}

/**
 * short summary of wavesim message which has a lot of data
 */
export function shortDWSM(ws) {
    return toText(`WS<${FastSimulation__get_SimulatedTopSheet(getFastSim())}->${ws.StartCycle}-${ws.CursorDisplayCycle}-${ws.ShownCycles} Waves:${FSharpMap__get_Count(ws.WaveDetails)} (${length(ws.SelectedWaves)})>`);
}

/**
 * Function returning a short but usually informative display of message
 * used when message tracing (see Sheet menu to which on or off).
 * Parameters that might be very large (like fastsimulation, or Model, or Symbols) should not be
 * displayed using printf "%A".
 */
export function shortDisplayMsg(msg) {
    let option_1;
    let matchResult, code, n, op, epoch, n_1, e, n_2, answer, n_3, n_4, fc, sheetMsg_1, x, s, ws, ws_1, serial, ttMsg, comps, conns, x_2, p, pos, folder, n_6;
    switch (msg.tag) {
        case 1: {
            matchResult = 5;
            break;
        }
        case 124:
        case 42:
        case 126:
        case 43:
        case 44:
        case 123: {
            matchResult = 7;
            break;
        }
        case 5: {
            matchResult = 8;
            break;
        }
        case 4:
        case 2:
        case 7:
        case 6: {
            matchResult = 10;
            break;
        }
        case 13: {
            matchResult = 17;
            break;
        }
        case 14: {
            matchResult = 18;
            break;
        }
        case 16: {
            matchResult = 19;
            break;
        }
        case 17: {
            matchResult = 20;
            break;
        }
        case 18: {
            matchResult = 21;
            break;
        }
        case 19: {
            matchResult = 22;
            break;
        }
        case 20: {
            matchResult = 24;
            break;
        }
        case 21:
        case 22:
        case 23: {
            matchResult = 25;
            break;
        }
        case 24: {
            matchResult = 26;
            break;
        }
        case 25: {
            matchResult = 27;
            break;
        }
        case 26:
        case 27:
        case 28:
        case 29: {
            matchResult = 28;
            break;
        }
        case 122:
        case 33: {
            matchResult = 30;
            break;
        }
        case 34: {
            matchResult = 31;
            break;
        }
        case 37: {
            matchResult = 34;
            break;
        }
        case 38: {
            matchResult = 35;
            break;
        }
        case 39: {
            matchResult = 36;
            break;
        }
        case 40:
        case 41:
        case 45:
        case 46:
        case 49:
        case 50:
        case 51:
        case 54:
        case 52:
        case 53:
        case 55:
        case 56:
        case 57:
        case 58:
        case 59:
        case 60:
        case 61:
        case 62:
        case 63:
        case 64:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72: {
            matchResult = 37;
            break;
        }
        case 74: {
            matchResult = 39;
            break;
        }
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 90:
        case 94:
        case 99:
        case 100:
        case 101:
        case 120: {
            matchResult = 40;
            break;
        }
        case 121:
        case 102: {
            matchResult = 41;
            break;
        }
        case 89: {
            matchResult = 42;
            break;
        }
        case 92: {
            matchResult = 44;
            break;
        }
        case 96: {
            matchResult = 47;
            break;
        }
        case 97: {
            matchResult = 48;
            break;
        }
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 98:
        case 112:
        case 113:
        case 9:
        case 114: {
            matchResult = 49;
            break;
        }
        case 115: {
            matchResult = 50;
            break;
        }
        case 116: {
            matchResult = 51;
            break;
        }
        case 117: {
            matchResult = 52;
            break;
        }
        case 118: {
            matchResult = 53;
            break;
        }
        case 119: {
            matchResult = 54;
            break;
        }
        case 127: {
            matchResult = 55;
            break;
        }
        case 65: {
            matchResult = 56;
            break;
        }
        case 66: {
            matchResult = 57;
            break;
        }
        case 47: {
            matchResult = 58;
            break;
        }
        case 48: {
            matchResult = 59;
            break;
        }
        case 30: {
            matchResult = 1;
            n = msg.fields[0].fields[0];
            op = msg.fields[1];
            break;
        }
        case 31: {
            if (msg.fields[1].tag === 0) {
                if (msg.fields[1].fields[0].tag === 1) {
                    matchResult = 3;
                    e = msg.fields[1].fields[0].fields[0];
                    n_2 = msg.fields[0].fields[0];
                }
                else {
                    matchResult = 2;
                    epoch = msg.fields[1].fields[0].fields[0];
                    n_1 = msg.fields[0].fields[0];
                }
            }
            else {
                matchResult = 4;
                answer = msg.fields[1];
                n_3 = msg.fields[0].fields[0];
            }
            break;
        }
        case 125: {
            matchResult = 6;
            n_4 = msg.fields[0];
            break;
        }
        case 111: {
            matchResult = 9;
            fc = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 11;
            sheetMsg_1 = msg.fields[0];
            break;
        }
        case 8: {
            if (msg.fields[0].tag === 0) {
                matchResult = 12;
            }
            else {
                matchResult = 13;
            }
            break;
        }
        case 10: {
            matchResult = 14;
            x = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 15;
            s = msg.fields[0][0];
            ws = msg.fields[0][1];
            break;
        }
        case 12: {
            matchResult = 16;
            ws_1 = msg.fields[0];
            break;
        }
        case 15: {
            matchResult = 23;
            serial = msg.fields[0];
            break;
        }
        case 32: {
            matchResult = 29;
            ttMsg = msg.fields[0];
            break;
        }
        case 35: {
            matchResult = 32;
            comps = msg.fields[0];
            conns = msg.fields[1];
            break;
        }
        case 36: {
            matchResult = 33;
            x_2 = msg.fields[0];
            break;
        }
        case 73: {
            matchResult = 38;
            p = msg.fields[0];
            break;
        }
        case 91: {
            matchResult = 43;
            pos = msg.fields[0];
            break;
        }
        case 93: {
            matchResult = 45;
            folder = msg.fields[0];
            break;
        }
        case 95: {
            matchResult = 46;
            n_6 = msg.fields[0];
            break;
        }
        default: {
            matchResult = 0;
            code = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return `AnyKeyPress ${interpolate("%A%P()", [code])}`;
        case 1:
            return `SidecarOpStarted #${n} ${interpolate("%A%P()", [op])}`;
        case 2:
            return `SidecarReply #${n_1} built session ${epoch}`;
        case 3:
            return `SidecarReply #${n_2} build failed: ${e}`;
        case 4:
            return `SidecarReply #${n_3} ${interpolate("%A%P()", [answer])}`;
        case 5:
            return undefined;
        case 6:
            return defaultArg((option_1 = tryItem(n_4, Constants_multipliers), (option_1 != null) ? (`Set WS multiplier to ${option_1}`) : undefined), `Invalid Ws mult key of ${n_4}`);
        case 7:
            return undefined;
        case 8:
            return "SheetBackAction";
        case 9:
            return `${fc}`;
        case 10:
            return undefined;
        case 11:
            return shortDSheetMsg(sheetMsg_1);
        case 12:
            return "JSDiagramMsg.InitCanvas";
        case 13:
            return undefined;
        case 14:
            return concat("StartSimulation(", (x.tag === 1) ? "Error" : "OK", ")");
        case 15:
            return `AddWSModel:${s}->${shortDWSM(ws)}`;
        case 16:
            return `SetWSModel:${FastSimulation__get_SimulatedTopSheet(getFastSim())}->${shortDWSM(ws_1)}`;
        case 17:
            return "Updating WS model";
        case 18:
            return "GenerateWaveforms";
        case 19:
            return "Generate Current Waveforms";
        case 20:
            return "CancelWaveSimulation";
        case 21:
            return "StartWaveSimulation";
        case 22:
            return "RefreshWaveSim";
        case 23:
            return `WaveScrollSettled #${serial}`;
        case 24:
            return "SetWaveSheetSelectionOpen";
        case 25:
            return undefined;
        case 26:
            return "TryStartSimulationAfterErrorFix";
        case 27:
            return "SetSimulationGraph";
        case 28:
            return undefined;
        case 29:
            switch (ttMsg.tag) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                    return undefined;
                case 18:
                    return "SetIOOrder";
                case 19:
                    return undefined;
                case 20:
                    return undefined;
                case 21:
                    return "SetTTGridCache";
                case 22:
                    return "TogglePopupAlgebraInput";
                case 23:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 33:
                case 34:
                case 29:
                case 30:
                case 31:
                case 32:
                    return undefined;
                default:
                    return "GenerateTruthTable";
            }
        case 30:
            return undefined;
        case 31:
            return undefined;
        case 32:
            return `SetHighlighted: ${length(comps)} comps, ${length(conns)} conns`;
        case 33:
            return `SetSelWavesHighlighted${x_2.length}`;
        case 34:
            return "SetClipboard";
        case 35:
            return "SetCreateComponent";
        case 36:
            return "SetProject";
        case 37:
            return undefined;
        case 38:
            return `StartStepRun ${p.InitialClock}->${p.FinalClock}`;
        case 39:
            return "SetSelectedComponentMemoryLocation";
        case 40:
            return undefined;
        case 41:
            return "Selection has changed";
        case 42:
            return "StartDragPlacement";
        case 43:
            return `DropDragPlacement at ${pos}`;
        case 44:
            return "EndDragPlacement";
        case 45:
            return concat("Browsing ", folder);
        case 46:
            return `Browser selection moves by ${n_6}`;
        case 47:
            return "Browser up";
        case 48:
            return "Browser open selection";
        case 49:
            return undefined;
        case 50:
            return "ExecCmd";
        case 51:
            return "ExecFuncInMessage";
        case 52:
            return "ExecFuncAsync";
        case 53:
            return "ExecCmdAsynch";
        case 54:
            return "SendSeqMsgAsynch";
        case 55:
            return "CodeEditorMsg";
        case 56:
            return "CheckTopSheetChoice";
        case 57:
            return "PropagateParameters";
        case 58:
            return "ProblemLogged";
        default:
            return "SetSuppressErrorPopups";
    }
}

/**
 * Human-readable info on a message, or "" for one not worth showing.
 * 
 * Never `%A` on the message itself: a Msg can carry a whole FastSimulation, a Model or a canvas,
 * and printing one of those crashes the renderer. shortDisplayMsg names every case by hand for
 * exactly that reason. Mouse drags and moves are suppressed unless Log.Mouse is on, since they
 * are the majority of all messages and would bury everything else.
 */
export function getMessageTraceString(msg) {
    let _arg;
    if (matchMouseMsg((op) => {
        if (equals(op, MouseOp.Drag) ? true : equals(op, MouseOp.Move)) {
            return !((enabled() & 1024) !== 0);
        }
        else {
            return false;
        }
    }, msg) ? true : ((_arg = msg, (_arg.tag === 3) && ((_arg.fields[0].tag === 0) && ((_arg.fields[0].fields[0].tag === 0) && ((_arg.fields[0].fields[0].fields[0].tag === 0) ? true : (_arg.fields[0].fields[0].fields[0].tag === 9))))))) {
        return "";
    }
    else {
        const matchValue = shortDisplayMsg(msg);
        if (matchValue == null) {
            return sprintInitial(70, `${msg}`);
        }
        else {
            return matchValue;
        }
    }
}

/**
 * Count the message just handled, and trace it if Log.Update is on.
 * 
 * The counting is unconditional and costs an add and a compare: the message name is only built
 * when this message was the slowest so far, which is what makes the periodic summary affordable.
 */
export function traceMessage(startOfUpdateTime, msg, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const updateTime = getTimeMs() - startOfUpdateTime;
    countMessage(updateTime, () => getMessageTraceString(msg));
    if ((enabled() & 1) !== 0) {
        const matchValue = getMessageTraceString(msg);
        if (matchValue === "") {
        }
        else {
            dbg(1, `${interpolate("%6.1f%P()", [updateTime])}ms ${matchValue}`);
        }
    }
    return [_arg[0], _arg[1]];
}

export let lastMemoryUpdateCheck = createAtom(0);

export function updateAllMemoryCompsIfNeeded(model) {
    const time = getTimeMs();
    if (((time - lastMemoryUpdateCheck()) > Constants_memoryUpdateCheckTime) && equals(getWSModel(model).State, WaveSimState.Success)) {
        lastMemoryUpdateCheck(time);
        return updateAllMemoryComps(model);
    }
    else {
        return model;
    }
}

export function verilogOutputPage(sheet, fPath) {
    let s_3;
    const children = [`You can write sheet '${sheet}' (and its subsheets) in either simulation or synthesis format. The output will be written to:`, Text_div(ofArray([new Common_GenericOption(/* Modifiers */ 2, [singleton(new Modifier_IModifier(/* TextWeight */ 2, [TextWeight_Option.Bold]))]), new Common_GenericOption(/* Props */ 1, [singleton(["style", {
        textAlign: "center",
        padding: "10px",
        fontFamily: "monospace",
        fontSize: "15px",
    }])])]), singleton(concat(cropToLength(55, false, fPath), ".v"))), columns(empty(), ofArray([column(empty(), singleton(panel(singleton(new Option(/* Color */ 0, [Color_IColor.IsInfo])), ofArray([heading(empty(), singleton("Simulation output")), Block_div(empty(), singleton((s_3 = "Simulation output will run on an online synthesis tool such as Icarus v10 to check that Issie\'s Verilog output is working", s_3))), Block_div(empty(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsSuccess]), Option_1.IsFullWidth, new Option_1(/* OnClick */ 18, [(_arg) => {
        openInBrowser("https://www.tutorialspoint.com/compile_verilog_online.php", _arg);
    }])]), singleton("Icarus v10 Verilog simulator"))))])))), column(empty(), singleton(panel(singleton(new Option(/* Color */ 0, [Color_IColor.IsInfo])), ofArray([heading(empty(), singleton("Synthesis output")), Block_div(empty(), singleton("Synthesis output can be used as input to FPGA synthesis tools.")), Block_div(empty(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsSuccess]), Option_1.IsFullWidth, new Option_1(/* OnClick */ 18, [(_arg_1) => {
        openInBrowser("https://github.com/edstott/issie-synth", _arg_1);
    }])]), singleton("Instructions for synthesis work-flow"))))]))))]))];
    return react.createElement("div", {}, ...children);
}

/**
 * Ask which Verilog flavour to write for a sheet, then write it.
 * Reached from the sheet's pill in the sheet menu, so it names the sheet rather than assuming
 * whichever one happens to be open.
 */
export function verilogOutputPopup(sheetName, model, dispatch) {
    mapOverProject(undefined, model, (p) => {
        choicePopup("Verilog Output", verilogOutputPage(sheetName, pathJoin([p.ProjectPath, sheetName])), "Write Synthesis Verilog", "Write Simulation Verilog", (forSim, _arg) => {
            verilogOutputForSheet(sheetName, forSim ? VMode.ForSynthesis : VMode.ForSimulation, model, dispatch);
            dispatch(Msg.ClosePopup);
        }, dispatch);
    });
}

export class RightClickElement extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DBCustomComp", "DBScalingBox", "DBComp", "DBWire", "DBCanvas", "DBInputPort", "DBOutputPort", "IssieElement", "SheetMenuBreadcrumb", "CatalogueLibrary", "ProjectPathBreadcrumb", "WaveSimHelp", "NoMenu"];
    }
    static WaveSimHelp = new RightClickElement(11, []);
    static NoMenu = new RightClickElement(12, []);
}

export function RightClickElement_$reflection() {
    return union_type("UpdateHelpers.RightClickElement", [], RightClickElement, () => [[["Item1", DrawModelType_SymbolT_Symbol_$reflection()], ["Item2", CustomComponentType_$reflection()]], [["Item", list_type(int32_type)]], [["Item", DrawModelType_SymbolT_Symbol_$reflection()]], [["Wire", DrawModelType_BusWireT_Wire_$reflection()], ["ASeg", list_type(DrawModelType_BusWireT_ASegment_$reflection())]], [["Item", XYPos_$reflection()]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Sheet", SheetTree_$reflection()], ["IsSubSheet", bool_type]], [["Item", ComponentLibrary_$reflection()]], [["Path", string_type]], [], []]);
}

export let rightClickElement = createAtom(RightClickElement.NoMenu);

/**
 * Function that works out from the right-click event and model
 * what the current context menu should be.
 * output should be a menu name as defined in ContextMenus.contextMenus, or "" for no menu.
 */
export function getContextMenu(e, model) {
    let option_1, name, option_4, nameParts, option_9, p_1, option_7, matchValue_2, ct, sym_1, _arg, wire, segs, option_18, ct_1, option_15, option_13;
    const symbols = model.Sheet.Wire.Symbol.Symbols;
    const bwModel = model.Sheet.Wire;
    const sheetXYPos = getDrawBlockPos(e, getHeaderHeight(), model.Sheet);
    const element = e.target;
    let htmlId;
    try {
        htmlId = element.id;
    }
    catch (e_1) {
        htmlId = "invalid";
    }
    let elType;
    try {
        elType = element.nodeName;
    }
    catch (e_2) {
        elType = "invalid";
    }
    const drawOn = mouseOn(model.Sheet, sheetXYPos);
    let mouseInScalingBox;
    const matchValue = model.Sheet.ScalingBox;
    if (matchValue != null) {
        const pos = sheetXYPos;
        const boundingBox = matchValue.ScalingBoxBound;
        const yBox = boundingBox.TopLeft.Y;
        const xBox = boundingBox.TopLeft.X;
        mouseInScalingBox = ((((pos.X >= (xBox - 50)) && (pos.X <= ((xBox + boundingBox.W) + 50))) && (pos.Y >= (yBox - 50))) && (pos.Y <= ((yBox + boundingBox.H) + 50)));
    }
    else {
        mouseInScalingBox = false;
    }
    rightClickElement((htmlId === "refreshButton") ? RightClickElement.WaveSimHelp : ((htmlId === "selectButton") ? RightClickElement.WaveSimHelp : ((htmlId === "selectRamButton") ? RightClickElement.WaveSimHelp : ((htmlId === "startEndButton") ? RightClickElement.WaveSimHelp : ((htmlId === "ProjectPath") ? defaultArg((option_1 = model.CurrentProj, (option_1 != null) ? (new RightClickElement(/* ProjectPathBreadcrumb */ 10, [option_1.ProjectPath])) : undefined), RightClickElement.NoMenu) : ((htmlId === "WaveSimHelp") ? (StringModule_StartsWith("CatalogueLibrary:", htmlId) ? ((name = substring(htmlId, StringModule_Length("CatalogueLibrary:")), defaultArg((option_4 = tryFind((lib) => (lib.Name === name), model.ComponentLibraries), (option_4 != null) ? (new RightClickElement(/* CatalogueLibrary */ 9, [option_4])) : undefined), RightClickElement.NoMenu))) : (StringModule_StartsWith("SheetMenuBreadcrumb:", htmlId) ? ((nameParts = split(htmlId, [":"], undefined, 1), defaultArg(flatten((option_9 = model.CurrentProj, (option_9 != null) ? some((p_1 = option_9, (option_7 = tryFind_1(item_13(1, nameParts), getSheetTrees(false, p_1)), (option_7 != null) ? (new RightClickElement(/* SheetMenuBreadcrumb */ 8, [option_7, nameParts.length > 2])) : undefined))) : undefined)), RightClickElement.NoMenu))) : ((drawOn.tag === 6) ? ((elType === "path") ? RightClickElement.WaveSimHelp : RightClickElement.WaveSimHelp) : ((drawOn.tag === 3) ? RightClickElement.WaveSimHelp : ((drawOn.tag === 4) ? RightClickElement.WaveSimHelp : ((drawOn.tag === 1) ? RightClickElement.WaveSimHelp : ((drawOn.tag === 2) ? RightClickElement.WaveSimHelp : RightClickElement.WaveSimHelp))))))) : ((htmlId === "DrawBlockSVGTop") ? (StringModule_StartsWith("CatalogueLibrary:", htmlId) ? ((name = substring(htmlId, StringModule_Length("CatalogueLibrary:")), defaultArg((option_4 = tryFind((lib) => (lib.Name === name), model.ComponentLibraries), (option_4 != null) ? (new RightClickElement(/* CatalogueLibrary */ 9, [option_4])) : undefined), RightClickElement.NoMenu))) : (StringModule_StartsWith("SheetMenuBreadcrumb:", htmlId) ? ((nameParts = split(htmlId, [":"], undefined, 1), defaultArg(flatten((option_9 = model.CurrentProj, (option_9 != null) ? some((p_1 = option_9, (option_7 = tryFind_1(item_13(1, nameParts), getSheetTrees(false, p_1)), (option_7 != null) ? (new RightClickElement(/* SheetMenuBreadcrumb */ 8, [option_7, nameParts.length > 2])) : undefined))) : undefined)), RightClickElement.NoMenu))) : ((drawOn.tag === 6) ? ((elType === "path") ? RightClickElement.WaveSimHelp : (mouseInScalingBox ? (new RightClickElement(/* DBScalingBox */ 1, [model.Sheet.SelectedComponents])) : (new RightClickElement(/* DBCanvas */ 4, [sheetXYPos])))) : ((drawOn.tag === 3) ? (mouseInScalingBox ? (new RightClickElement(/* DBScalingBox */ 1, [model.Sheet.SelectedComponents])) : ((matchValue_2 = tryFind_1(drawOn.fields[0], symbols), (matchValue_2 != null) ? ((matchValue_2.Component.Type.tag === 26) ? ((ct = matchValue_2.Component.Type.fields[0], new RightClickElement(/* DBCustomComp */ 0, [FSharpMap__get_Item(symbols, drawOn.fields[0]), ct]))) : (equals(matchValue_2.Annotation, undefined) ? ((sym_1 = matchValue_2, new RightClickElement(/* DBComp */ 2, [sym_1]))) : RightClickElement.NoMenu)) : RightClickElement.NoMenu))) : ((drawOn.tag === 4) ? ((_arg = tryFind_1(drawOn.fields[0], bwModel.Wires), (_arg != null) ? ((wire = _arg, (segs = getClickedSegment(bwModel, drawOn.fields[0], sheetXYPos), isEmpty(segs) ? RightClickElement.NoMenu : (new RightClickElement(/* DBWire */ 3, [wire, segs]))))) : RightClickElement.NoMenu)) : ((drawOn.tag === 1) ? (new RightClickElement(/* DBInputPort */ 5, [toString(drawOn.fields[0])])) : ((drawOn.tag === 2) ? (new RightClickElement(/* DBOutputPort */ 6, [toString(drawOn.fields[0])])) : RightClickElement.NoMenu))))))) : (StringModule_StartsWith("CatalogueLibrary:", htmlId) ? ((name = substring(htmlId, StringModule_Length("CatalogueLibrary:")), defaultArg((option_4 = tryFind((lib) => (lib.Name === name), model.ComponentLibraries), (option_4 != null) ? (new RightClickElement(/* CatalogueLibrary */ 9, [option_4])) : undefined), RightClickElement.NoMenu))) : (StringModule_StartsWith("SheetMenuBreadcrumb:", htmlId) ? ((nameParts = split(htmlId, [":"], undefined, 1), defaultArg(flatten((option_9 = model.CurrentProj, (option_9 != null) ? some((p_1 = option_9, (option_7 = tryFind_1(item_13(1, nameParts), getSheetTrees(false, p_1)), (option_7 != null) ? (new RightClickElement(/* SheetMenuBreadcrumb */ 8, [option_7, nameParts.length > 2])) : undefined))) : undefined)), RightClickElement.NoMenu))) : ((drawOn.tag === 6) ? ((elType === "path") ? RightClickElement.WaveSimHelp : (new RightClickElement(/* IssieElement */ 7, [toString(element)]))) : ((drawOn.tag === 3) ? (mouseInScalingBox ? (new RightClickElement(/* DBScalingBox */ 1, [model.Sheet.SelectedComponents])) : ((matchValue_2 = tryFind_1(drawOn.fields[0], symbols), (matchValue_2 != null) ? ((matchValue_2.Component.Type.tag === 26) ? ((ct = matchValue_2.Component.Type.fields[0], new RightClickElement(/* DBCustomComp */ 0, [FSharpMap__get_Item(symbols, drawOn.fields[0]), ct]))) : (equals(matchValue_2.Annotation, undefined) ? ((sym_1 = matchValue_2, new RightClickElement(/* DBComp */ 2, [sym_1]))) : RightClickElement.NoMenu)) : RightClickElement.NoMenu))) : ((drawOn.tag === 4) ? ((_arg = tryFind_1(drawOn.fields[0], bwModel.Wires), (_arg != null) ? ((wire = _arg, (segs = getClickedSegment(bwModel, drawOn.fields[0], sheetXYPos), isEmpty(segs) ? RightClickElement.NoMenu : (new RightClickElement(/* DBWire */ 3, [wire, segs]))))) : RightClickElement.NoMenu)) : ((drawOn.tag === 1) ? (new RightClickElement(/* DBInputPort */ 5, [toString(drawOn.fields[0])])) : ((drawOn.tag === 2) ? (new RightClickElement(/* DBOutputPort */ 6, [toString(drawOn.fields[0])])) : RightClickElement.NoMenu))))))))))))));
    const ifWavesToOffer = (sym_2, waveSimMenu, menu) => {
        if (!equals(compWavesToOffer(model, sym_2.Id), empty())) {
            return waveSimMenu;
        }
        else {
            return menu;
        }
    };
    const readOnly = openSheetIsReadOnly(model);
    if (rightClickElement().tag === 8) {
        if (contains(rightClickElement().fields[0].SheetName, model.OpenedLibrarySheets)) {
            const sheet_2 = rightClickElement().fields[0];
            return "SheetMenuBreadcrumbLibrary";
        }
        else {
            const sheet_3 = rightClickElement().fields[0];
            const offersSetAsTop = defaultArg((option_18 = model.CurrentProj, (option_18 != null) ? topSheetChoiceMatters(option_18.LoadedComponents, sheet_3.SheetName) : undefined), false);
            return ("SheetMenuBreadcrumb" + ((debugLevel() > 0) ? "Dev" : "")) + (offersSetAsTop ? "" : "NoTop");
        }
    }
    else if (rightClickElement().tag === 9) {
        return "CatalogueLibrary";
    }
    else if (rightClickElement().tag === 10) {
        return "ProjectPath";
    }
    else if (rightClickElement().tag === 1) {
        if (readOnly) {
            return "";
        }
        else {
            return "ScalingBox";
        }
    }
    else if (rightClickElement().tag === 0) {
        if ((rightClickElement().fields[0], (ct_1 = rightClickElement().fields[1], defaultArg((option_15 = ((option_13 = model.CurrentProj, (option_13 != null) ? getFileInProject(ct_1.Name, option_13) : undefined)), (option_15 != null) ? isLibrarySheet(option_15) : undefined), false)))) {
            const ct_3 = rightClickElement().fields[1];
            const sym_4 = rightClickElement().fields[0];
            const viewed = contains(ct_3.Name, model.OpenedLibrarySheets);
            if (readOnly) {
                if (viewed) {
                    return "LibraryInstanceOpenReadOnly";
                }
                else {
                    return "LibraryInstanceReadOnly";
                }
            }
            else if (viewed) {
                return ifWavesToOffer(sym_4, "LibraryInstanceOpenWaveSim", "LibraryInstanceOpen");
            }
            else {
                return ifWavesToOffer(sym_4, "LibraryInstanceWaveSim", "LibraryInstance");
            }
        }
        else {
            const sym_5 = rightClickElement().fields[0];
            if (readOnly) {
                return "ComponentReadOnly";
            }
            else {
                return ifWavesToOffer(sym_5, "CustomComponentWaveSim", "CustomComponent");
            }
        }
    }
    else if (rightClickElement().tag === 2) {
        const sym_6 = rightClickElement().fields[0];
        if (readOnly) {
            return "ComponentReadOnly";
        }
        else {
            return ifWavesToOffer(sym_6, "ComponentWaveSim", "Component");
        }
    }
    else if (rightClickElement().tag === 4) {
        if (readOnly) {
            return "CanvasReadOnly";
        }
        else {
            return "Canvas";
        }
    }
    else if (rightClickElement().tag === 3) {
        const wire_1 = rightClickElement().fields[0];
        if (readOnly) {
            return "";
        }
        else if (wireWaveToOffer(model, wire_1.WId) != null) {
            return "WireWaveSim";
        }
        else {
            return "Wire";
        }
    }
    else if (rightClickElement().tag === 11) {
        return "WaveSimHelp";
    }
    else {
        dbg(16, concat("right-clicked on \'", toString(drawOn), "\', which has no context menu"));
        return "";
    }
}

/**
 * Open a library component's sheet to be looked at, and go to it.
 * 
 * The sheet becomes visible in the Sheets menu and stays reachable until the project is closed,
 * but is read-only throughout: it is not the user's to change, and a library component that
 * differed from the library it came from would not be one. Only this sheet is opened - a
 * component built from other library components keeps them shut, each needing the same
 * deliberate click of its own.
 */
export function viewLibrarySheet(name, model, dispatch) {
    const p = value_25(model.CurrentProj);
    const model_1 = Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, openedLibrarySheets_)((set$) => add(name, set$))(model);
    openFileInProject(name, p, model_1, dispatch);
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, uISheetTrail_)((trail) => cons(p.OpenFileName, trail))(model_1);
}

/**
 * Put a viewed library component's sheet away again.
 * 
 * If it is the sheet on screen the user has to be taken off it first, since it is about to
 * become unreachable: back the way they came, or failing that to any sheet of their own. With
 * nowhere at all to go the sheet stays open, rather than stranding the user on a sheet the rest
 * of Issie has stopped believing in.
 * 
 * The order matters. Leaving a sheet writes it back - to the loaded components, and to a backup
 * file - and what stops that for a library sheet is its being in OpenedLibrarySheets. So the
 * sheet is left while it is still marked, and put away only in the model this returns.
 */
export function hideLibrarySheet(name, model, dispatch) {
    const p = value_25(model.CurrentProj);
    const putAway = (model_1) => Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, openedLibrarySheets_)((set$) => remove(name, set$))(model_1);
    if (p.OpenFileName !== name) {
        return putAway(model);
    }
    else {
        let goTo;
        const option_3 = tryHead(filter((sheet) => {
            if (sheet !== name) {
                return exists((ldc) => (ldc.Name === sheet), p.LoadedComponents);
            }
            else {
                return false;
            }
        }, model.UISheetTrail));
        if (option_3 != null) {
            goTo = option_3;
        }
        else {
            const option_1 = tryFind((ldc_1) => {
                if (ldc_1.Name !== name) {
                    return !isLibrarySheet(ldc_1);
                }
                else {
                    return false;
                }
            }, p.LoadedComponents);
            goTo = ((option_1 != null) ? option_1.Name : undefined);
        }
        if (goTo != null) {
            const sheet_1 = goTo;
            openFileInProject(sheet_1, p, model, dispatch);
            return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, uISheetTrail_)((list_3) => filter((s) => (s !== sheet_1), list_3))(putAway(model));
        }
        else {
            warn(concat("there is no sheet to return to, so \'", name, "\' has been left open"));
            return model;
        }
    }
}

/**
 * Function that implement action based on context menu item click.
 * menuType is the menu from chooseContextMenu.
 * item will be one of the possible items in this menu.
 */
export function processContextMenuClick(menuType, item, dispatch, model) {
    let text, l_20, l_28, optic_28, f_7, wires;
    const withNoCmd = (model_1) => [model_1, Cmd_none()];
    const withMsg = (msg, model_2) => [model_2, singleton((dispatch_1) => {
        dispatch_1(msg);
    })];
    const withMsgs = (msgs, model_3) => [model_3, Cmd_batch(map((msg_2) => singleton((dispatch_2) => {
        dispatch_2(msg_2);
    }), msgs))];
    const withWireMsg = (msg_4) => curry2(withMsg)(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [msg_4])]));
    const sheetDispatch = (arg) => {
        dispatch(new Msg(/* Sheet */ 3, [arg]));
    };
    const keyDispatch = (arg_1) => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [arg_1]));
    };
    const rotateDispatch = (arg_2) => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Rotate */ 34, [arg_2]));
    };
    const flipDispatch = (arg_3) => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Flip */ 35, [arg_3]));
    };
    const matchValue = rightClickElement();
    let matchResult, sheet_1, sheet_2, sheet_3, sheet_4, sheet_5, sheet_6, isSubSheet, sheet_7, isSubSheet_1, sheet_8, isSubSheet_2, sheet_9, isSubSheet_3, sheet_10, library, path, path_1, sym, ct_8, item_10, ct_9, item_11, item_12, sheet_11, ct_10, sym_1, sym_2, sym_3, sym_4, sym_5, sym_6, sym_7, wire, aSeg, wire_1, selectedcomps, selectedcomps_1, selectedcomps_2, selectedcomps_3, pos, pos_1, pos_2, feature;
    switch (matchValue.tag) {
        case 8: {
            switch (item) {
                case "Rename": {
                    matchResult = 0;
                    sheet_1 = matchValue.fields[0];
                    break;
                }
                case "Duplicate": {
                    matchResult = 1;
                    sheet_2 = matchValue.fields[0];
                    break;
                }
                case "Delete": {
                    matchResult = 2;
                    sheet_3 = matchValue.fields[0];
                    break;
                }
                case "Save as library component": {
                    matchResult = 3;
                    sheet_4 = matchValue.fields[0];
                    break;
                }
                case "Set as top": {
                    matchResult = 4;
                    sheet_5 = matchValue.fields[0];
                    break;
                }
                case "Write design as Verilog": {
                    matchResult = 5;
                    sheet_6 = matchValue.fields[0];
                    break;
                }
                case "Lock": {
                    matchResult = 6;
                    isSubSheet = matchValue.fields[1];
                    sheet_7 = matchValue.fields[0];
                    break;
                }
                case "Unlock": {
                    matchResult = 7;
                    isSubSheet_1 = matchValue.fields[1];
                    sheet_8 = matchValue.fields[0];
                    break;
                }
                case "Lock Subtree": {
                    matchResult = 8;
                    isSubSheet_2 = matchValue.fields[1];
                    sheet_9 = matchValue.fields[0];
                    break;
                }
                case "Unlock Subtree": {
                    matchResult = 9;
                    isSubSheet_3 = matchValue.fields[1];
                    sheet_10 = matchValue.fields[0];
                    break;
                }
                default:
                    if (item === hideLibraryItem) {
                        matchResult = 16;
                        item_12 = item;
                        sheet_11 = matchValue.fields[0];
                    }
                    else {
                        matchResult = 41;
                    }
            }
            break;
        }
        case 9: {
            if (item === "Export library") {
                matchResult = 10;
                library = matchValue.fields[0];
            }
            else {
                matchResult = 41;
            }
            break;
        }
        case 10: {
            switch (item) {
                case "Copy path": {
                    matchResult = 11;
                    path = matchValue.fields[0];
                    break;
                }
                case "Open directory": {
                    matchResult = 12;
                    path_1 = matchValue.fields[0];
                    break;
                }
                default:
                    matchResult = 41;
            }
            break;
        }
        case 0: {
            switch (item) {
                case "Move ports": {
                    matchResult = 13;
                    sym = matchValue.fields[0];
                    break;
                }
                case "Resize symbol": {
                    matchResult = 13;
                    sym = matchValue.fields[0];
                    break;
                }
                case "Go to sheet": {
                    if (item === viewLibraryItem) {
                        matchResult = 14;
                        ct_8 = matchValue.fields[1];
                        item_10 = item;
                    }
                    else if (item === hideLibraryItem) {
                        matchResult = 15;
                        ct_9 = matchValue.fields[1];
                        item_11 = item;
                    }
                    else {
                        matchResult = 17;
                        ct_10 = matchValue.fields[1];
                    }
                    break;
                }
                case "Properties": {
                    if (item === viewLibraryItem) {
                        matchResult = 14;
                        ct_8 = matchValue.fields[1];
                        item_10 = item;
                    }
                    else if (item === hideLibraryItem) {
                        matchResult = 15;
                        ct_9 = matchValue.fields[1];
                        item_11 = item;
                    }
                    else {
                        matchResult = 22;
                        sym_5 = matchValue.fields[0];
                    }
                    break;
                }
                case "Add waveforms to viewer": {
                    if (item === viewLibraryItem) {
                        matchResult = 14;
                        ct_8 = matchValue.fields[1];
                        item_10 = item;
                    }
                    else if (item === hideLibraryItem) {
                        matchResult = 15;
                        ct_9 = matchValue.fields[1];
                        item_11 = item;
                    }
                    else {
                        matchResult = 23;
                        sym_6 = matchValue.fields[0];
                    }
                    break;
                }
                default:
                    if (item === viewLibraryItem) {
                        matchResult = 14;
                        ct_8 = matchValue.fields[1];
                        item_10 = item;
                    }
                    else if (item === hideLibraryItem) {
                        matchResult = 15;
                        ct_9 = matchValue.fields[1];
                        item_11 = item;
                    }
                    else {
                        matchResult = 41;
                    }
            }
            break;
        }
        case 2: {
            switch (item) {
                case "Rotate Clockwise": {
                    matchResult = 18;
                    sym_1 = matchValue.fields[0];
                    break;
                }
                case "Rotate AntiClockwise": {
                    matchResult = 19;
                    sym_2 = matchValue.fields[0];
                    break;
                }
                case "Flip Vertical": {
                    matchResult = 20;
                    sym_3 = matchValue.fields[0];
                    break;
                }
                case "Flip Horizontal": {
                    matchResult = 21;
                    sym_4 = matchValue.fields[0];
                    break;
                }
                case "Properties": {
                    matchResult = 22;
                    sym_5 = matchValue.fields[0];
                    break;
                }
                case "Add waveforms to viewer": {
                    matchResult = 23;
                    sym_6 = matchValue.fields[0];
                    break;
                }
                case "Delete": {
                    matchResult = 24;
                    break;
                }
                case "Copy": {
                    matchResult = 25;
                    sym_7 = matchValue.fields[0];
                    break;
                }
                default:
                    matchResult = 41;
            }
            break;
        }
        case 3: {
            switch (item) {
                case "Add wave to viewer": {
                    matchResult = 26;
                    wire = matchValue.fields[0];
                    break;
                }
                case "Unfix Wire": {
                    matchResult = 27;
                    aSeg = matchValue.fields[1];
                    wire_1 = matchValue.fields[0];
                    break;
                }
                default:
                    matchResult = 41;
            }
            break;
        }
        case 1: {
            switch (item) {
                case "Rotate Clockwise": {
                    matchResult = 28;
                    selectedcomps = matchValue.fields[0];
                    break;
                }
                case "Rotate AntiClockwise": {
                    matchResult = 29;
                    selectedcomps_1 = matchValue.fields[0];
                    break;
                }
                case "Flip Vertical": {
                    matchResult = 30;
                    selectedcomps_2 = matchValue.fields[0];
                    break;
                }
                case "Flip Horizontal": {
                    matchResult = 31;
                    selectedcomps_3 = matchValue.fields[0];
                    break;
                }
                case "Delete Box": {
                    matchResult = 32;
                    break;
                }
                case "Copy Box": {
                    matchResult = 33;
                    break;
                }
                default:
                    matchResult = 41;
            }
            break;
        }
        case 4: {
            switch (item) {
                case "Zoom-in and centre": {
                    matchResult = 34;
                    pos = matchValue.fields[0];
                    break;
                }
                case "Zoom-out": {
                    matchResult = 35;
                    pos_1 = matchValue.fields[0];
                    break;
                }
                case "Fit to window": {
                    matchResult = 36;
                    break;
                }
                case "Paste": {
                    matchResult = 37;
                    pos_2 = matchValue.fields[0];
                    break;
                }
                case "Reroute all wires": {
                    matchResult = 38;
                    break;
                }
                case "Properties": {
                    matchResult = 40;
                    break;
                }
                default:
                    matchResult = 41;
            }
            break;
        }
        case 11: {
            matchResult = 39;
            feature = item;
            break;
        }
        default:
            matchResult = 41;
    }
    switch (matchResult) {
        case 0: {
            renameFileInProject(sheet_1.SheetName, (props) => ((children) => react.createElement("p", keyValueList(props, 1), ...children)), model, dispatch);
            return withNoCmd(model);
        }
        case 1: {
            duplicateSheet(sheet_2.SheetName, model, dispatch);
            return withNoCmd(model);
        }
        case 2: {
            deleteFileConfirmationPopup(sheet_3.SheetName, model, dispatch);
            return withNoCmd(model);
        }
        case 3: {
            saveAsLibraryComponent(sheet_4.SheetName, model, dispatch);
            return withNoCmd(model);
        }
        case 4:
            return withMsg(Msg.PropagateParameters, setTopSheetState(sheet_5.SheetName, model));
        case 5: {
            verilogOutputPopup(sheet_6.SheetName, model, dispatch);
            return withNoCmd(model);
        }
        case 6:
            return withNoCmd(changeLockState(isSubSheet, sheet_7, (_arg) => LockState.Locked)(model));
        case 7:
            return withNoCmd(changeLockState(isSubSheet_1, sheet_8, (_arg_1) => LockState.Unlocked)(model));
        case 8:
            return withNoCmd(changeSubtreeLockState(isSubSheet_2, sheet_9, (_arg_2) => LockState.Locked)(model));
        case 9:
            return withNoCmd(changeSubtreeLockState(isSubSheet_3, sheet_10, (_arg_3) => LockState.Unlocked)(model));
        case 10: {
            exportLibrary(library, dispatch);
            return withNoCmd(model);
        }
        case 11: {
            window.issieBridge.clipboardWrite(path);
            return withMsgs(ofArray([new Msg(/* SetFilesNotification */ 79, [(text = concat("Copied ", path), (dispatch_3) => successNotification(text, Msg.CloseFilesNotification, dispatch_3))]), new Msg(/* DispatchDelayed */ 42, [[Constants_copiedPathNotificationTime, Msg.CloseFilesNotification]])]), model);
        }
        case 12:
            return [model, Cmd_ofEffect((dispatch_4) => {
                openFolderInFileManager(path_1, (reason) => {
                    dispatch_4(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(concat("Could not open ", path_1, ": ", reason))]));
                });
            })];
        case 13: {
            const mode = (item === "Move ports") ? DrawModelType_SheetT_SymbolEditMode.EditPorts : DrawModelType_SheetT_SymbolEditMode.EditSize;
            return withMsgs(cons(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* SelectSymbols */ 11, [singleton(sym.Id)])])])]), map((m) => (new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [m])])])), (mode.tag === 1) ? ofArray([new DrawModelType_SymbolT_Msg(/* ShowPorts */ 9, [empty()]), new DrawModelType_SymbolT_Msg(/* ShowCustomCorners */ 38, [singleton(sym.Id)])]) : ofArray([new DrawModelType_SymbolT_Msg(/* ShowCustomOnlyPorts */ 10, [singleton(sym.Id)]), new DrawModelType_SymbolT_Msg(/* HideCustomCorners */ 39, [singleton(sym.Id)])]))), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(singleton(sym.Id))(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedWires_)(sheet_))(empty())(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_symbolEdit_)(sheet_))([sym.Id, mode])(model))));
        }
        case 14:
            return withNoCmd(viewLibrarySheet(ct_8.Name, model, dispatch));
        case 15:
            return withNoCmd(hideLibrarySheet(ct_9.Name, model, dispatch));
        case 16:
            return withNoCmd(hideLibrarySheet(sheet_11.SheetName, model, dispatch));
        case 17: {
            const p = value_25(model.CurrentProj);
            openFileInProject(ct_10.Name, p, model, dispatch);
            return withNoCmd(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, uISheetTrail_)((trail) => cons(p.OpenFileName, trail))(model));
        }
        case 18: {
            rotateDispatch(Rotation.Degree90);
            return withNoCmd(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(singleton(sym_1.Id))(model));
        }
        case 19: {
            rotateDispatch(Rotation.Degree270);
            return withNoCmd(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(singleton(sym_2.Id))(model));
        }
        case 20: {
            flipDispatch("flipVertical");
            return withNoCmd(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(singleton(sym_3.Id))(model));
        }
        case 21: {
            flipDispatch("flipHorizontal");
            return withNoCmd(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(singleton(sym_4.Id))(model));
        }
        case 22:
            return withWireMsg(new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* SelectSymbols */ 11, [singleton(sym_5.Id)])]))(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, rightPaneTabVisible_)(RightTab.Properties)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(singleton(sym_5.Id))(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedWires_)(sheet_))(empty())(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, selectedComponent_)(sym_5.Component)(model)))));
        case 23:
            return withMsg(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, sym_6.Id, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, simSubTabVisible_)(SimSubTab.WaveSim)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, rightPaneTabVisible_)(RightTab.Simulation)(model)));
        case 24: {
            keyDispatch(DrawModelType_SheetT_KeyboardMsg.DEL);
            return withNoCmd(model);
        }
        case 25: {
            const model_7 = equals(model.Sheet.SelectedComponents, empty()) ? Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(singleton(sym_7.Id))(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, (l_20 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wire_)(sheet_), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_symbol_)(l_20)))((model_5) => {
                const model_6 = model_5;
                const resetSymbols = map_1((_arg_4, sym_8) => {
                    let f_1, f1_4, value_13, f2_4;
                    return Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, DrawModelType_SymbolT_moving_)(false)(((f_1 = ((f1_4 = ((value_13 = getSymbolColour(sym_8.Component.Type, sym_8.IsClocked, model_6.Theme), Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, DrawModelType_SymbolT_colour_)(value_13))), (f2_4 = Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, DrawModelType_SymbolT_opacity_)(1), (arg_31) => f2_4(f1_4(arg_31))))), Optic_Map_op_HatPercent_Z1462312A_1(Optic_Map.Map$, DrawModelType_SymbolT_appearance_)(f_1)))(sym_8));
                }, model_6.Symbols);
                return new DrawModelType_SymbolT_Model(fold((prevSymbols, sId) => add_1(sId, Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89_1(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_))("lightgreen")(Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, DrawModelType_SymbolT_moving_)(true)(FSharpMap__get_Item(resetSymbols, sId))), prevSymbols), resetSymbols, singleton(sym_7.Id)), model_6.CopiedSymbols, model_6.Ports, model_6.InputPortsConnected, model_6.OutputPortsConnected, model_6.Theme, model_6.HintPane);
            })(model)) : model;
            return withMsg(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlC])]), model_7);
        }
        case 26: {
            const matchValue_2 = wireWaveToOffer(model, wire.WId);
            if (matchValue_2 != null) {
                const wi = matchValue_2;
                return withMsg(new Msg(/* GenerateWaveforms */ 14, [(ws_1) => (contains_1(wi, ws_1.SelectedWaves, {
                    Equals: equals,
                    GetHashCode: (x) => (safeHash(x) | 0),
                }) ? ws_1 : (new WaveSimModel(ws_1.DefaultCursor, ws_1.WSConfig, ws_1.WSConfigDialog, ws_1.State, ws_1.WaveDetails, append(ws_1.SelectedWaves, singleton(wi)), ws_1.DefaultSelectionPending, ws_1.FetchFailedAtMs, ws_1.StartCycle, ws_1.ShownCycles, ws_1.SamplingZoom, ws_1.CursorDisplayCycle, ws_1.CursorExactClkCycle, ws_1.ClkCycleBoxIsEmpty, ws_1.Radix, ws_1.WaveformColumnWidth, ws_1.WaveModalActive, ws_1.RamModalActive, ws_1.PortSelectComp, ws_1.RamComps, ws_1.SelectedRams, ws_1.RamStartLocation, ws_1.RamRows, ws_1.ShowSheetDetail, ws_1.SelectedSheetInstance, ws_1.ShowGroupDetail, ws_1.HoveredLabel, ws_1.DraggedIndex, ws_1.PrevSelectedWaves, ws_1.ScrollbarTbWidth, ws_1.ScrollbarTbPos, ws_1.ScrollbarTbOffset, ws_1.ScrollbarBkgWidth, ws_1.ScrollbarBkgRepCycs, ws_1.ScrollbarQueueIsEmpty, ws_1.SheetSearchString, ws_1.ComponentSearchString, ws_1.PortSearchString, ws_1.ShowOnlySelected)))]), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, simSubTabVisible_)(SimSubTab.WaveSim)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, rightPaneTabVisible_)(RightTab.Simulation)(model)));
            }
            else {
                return withNoCmd(model);
            }
        }
        case 27: {
            const changeManualSegToAuto = Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_BusWireT_mode_)((_arg_5) => {
                if (_arg_5 === "manual") {
                    return "auto";
                }
                else {
                    return _arg_5;
                }
            });
            return withNoCmd(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wire_)(sheet_))((model_8) => separateAndOrderModelSegments(singleton(wire_1.WId), model_8))(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, (l_28 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wireOf_(wire_1.WId))(sheet_), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_segments_)(l_28)))((list_3) => map(changeManualSegToAuto, list_3))(model)));
        }
        case 28: {
            rotateDispatch(Rotation.Degree90);
            return withWireMsg(new DrawModelType_BusWireT_Msg(/* UpdateConnectedWires */ 20, [selectedcomps]))(model);
        }
        case 29: {
            rotateDispatch(Rotation.Degree270);
            return withWireMsg(new DrawModelType_BusWireT_Msg(/* UpdateConnectedWires */ 20, [selectedcomps_1]))(model);
        }
        case 30: {
            flipDispatch("flipVertical");
            return withWireMsg(new DrawModelType_BusWireT_Msg(/* UpdateConnectedWires */ 20, [selectedcomps_2]))(model);
        }
        case 31: {
            flipDispatch("flipHorizontal");
            return withWireMsg(new DrawModelType_BusWireT_Msg(/* UpdateConnectedWires */ 20, [selectedcomps_3]))(model);
        }
        case 32: {
            keyDispatch(DrawModelType_SheetT_KeyboardMsg.DEL);
            return withNoCmd(model);
        }
        case 33: {
            keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlC);
            return withNoCmd(model);
        }
        case 34:
            return withMsg(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeepZoomCentered */ 4, [pos])]), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_zoom_)(sheet_))((zoom) => min(Constants_maxMagnification, zoom * Constants_zoomIncrement))(model));
        case 35: {
            keyDispatch(DrawModelType_SheetT_KeyboardMsg.ZoomOut);
            return withNoCmd(model);
        }
        case 36: {
            keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlW);
            return withNoCmd(model);
        }
        case 37: {
            keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlV);
            return withNoCmd(model);
        }
        case 38: {
            keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlW);
            return withNoCmd(((optic_28 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wire_)(sheet_), (f_7 = ((wires = toList(FSharpMap__get_Keys(model.Sheet.Wire.Wires)), (model_9) => updateWireSegmentJumpsAndSeparations(wires, model_9))), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, optic_28)(f_7))))(model));
        }
        case 39: {
            viewWaveInfoPopup(dispatch, feature);
            return withNoCmd(model);
        }
        case 40:
            return withNoCmd(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, rightPaneTabVisible_)(RightTab.Properties)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedWires_)(sheet_))(empty())(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_selectedComponents_)(sheet_))(empty())(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, selectedComponent_)(undefined)(model)))));
        default: {
            warn(`context menu item not implemented: ${rightClickElement()} -> ${item}`);
            return withNoCmd(model);
        }
    }
}

export function filterByOKSheets(model, sheet) {
    const matchValue = model.CurrentProj;
    let matchResult, p_2, p_3;
    if (matchValue != null) {
        if (matchValue.OpenFileName === sheet) {
            matchResult = 0;
            p_2 = matchValue;
        }
        else if (forAll((ldc) => (ldc.Name !== sheet), matchValue.LoadedComponents)) {
            matchResult = 1;
            p_3 = matchValue;
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return false;
        case 1:
            return false;
        default:
            return true;
    }
}

/**
 * Adapter function to pipeline adding a default "Cmd.none" command to a model as returned
 * in update function.
 */
export function withNoMsg(model) {
    return [model, Cmd_none()];
}

/**
 * Implement action of top bar 'Back' button using the UISheetTrail
 */
export function processSheetBackAction(dispatch, model) {
    const goodSheets = filter((sheet) => filterByOKSheets(model, sheet), model.UISheetTrail);
    let trail;
    if (!isEmpty(goodSheets)) {
        openFileInProject(head(goodSheets), value_25(model.CurrentProj), model, dispatch);
        trail = tail(goodSheets);
    }
    else {
        trail = empty();
    }
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, uISheetTrail_)(trail)(model);
}

/**
 * Read persistent user data from file in userAppDir.
 * Store in Model UserData.
 */
export function readUserData(userAppDir, model) {
    let _arg;
    const addAppDirToUserData = (model_1) => {
        let bind$0040;
        return new Model(model_1.WindowWidth, model_1.KeyFocusPane, model_1.RunAfterRenderWithSpinner, (bind$0040 = model_1.UserData, new UserData_2(userAppDir, bind$0040.LastUsedDirectory, bind$0040.RecentProjects, bind$0040.ArrowDisplay, bind$0040.WireType, bind$0040.Theme)), model_1.WaveSim, model_1.WaveSimSheet, model_1.UISheetTrail, model_1.Spinner, model_1.Sheet, model_1.IsLoading, model_1.LastChangeCheckTime, model_1.LastSimulatedCanvasState, model_1.LastDetailedSavedState, model_1.CurrentSelected, model_1.LastSelectedIds, model_1.LastUsedDialogWidth, model_1.SelectedComponent, model_1.CurrentStepSimulationStep, model_1.CurrentTruthTable, model_1.TTConfig, model_1.RightPaneTabVisible, model_1.SimSubTabVisible, model_1.CircuitCheck, model_1.Hilighted, model_1.Clipboard, model_1.LastCreatedComponent, model_1.SavedSheetIsOutOfDate, model_1.PendingDragAddition, model_1.DragPlacement, model_1.ProjectBrowser, model_1.TopSheetChoiceDeclined, model_1.ComponentLibraries, model_1.OpenLibrary, model_1.CatalogueSearch, model_1.ArrayCopiesTyped, model_1.SimulateInRenderer, model_1.SidecarSession, model_1.ProbeRead, model_1.SidecarInFlight, model_1.SidecarBuildEndedMs, model_1.SidecarRunEndedMs, model_1.StepRunTarget, model_1.FetchedData, model_1.FetchedStructure, model_1.FailedFetch, model_1.StimulusGeneration, model_1.CurrentViewport, model_1.ViewportChangedAtMs, model_1.WaveScrollSettling, model_1.WaveScrollSerial, model_1.ShowLibrarySheets, model_1.SuppressErrorPopups, model_1.OpenedLibrarySheets, model_1.ReadOnlyBaseline, model_1.CurrentProj, model_1.PopupViewFunc, model_1.SpinnerPayload, model_1.PopupDialogData, model_1.Notifications, model_1.TopMenuOpenState, model_1.SheetMenuPinned, model_1.DividerDragMode, model_1.WaveSimViewerWidth, model_1.ConnsOfSelectedWavesAreHighlighted, model_1.Pending, model_1.UIState, model_1.BuildVisible, model_1.CodeEditorState);
    };
    let modelOpt;
    try {
        modelOpt = userDataToDrawBlockModel(addAppDirToUserData((_arg = Result_Bind((data) => (new FSharpResult$2(/* Ok */ 0, [new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, new UserData_2(data.UserAppDir, data.LastUsedDirectory, tidyRecents(data.RecentProjects), data.ArrowDisplay, data.WireType, data.Theme), model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState)])), Result_Bind((json) => {
            try {
                return new FSharpResult$2(/* Ok */ 0, [Convert_fromJson(SimpleJson_parseNative(json), createTypeInfo(UserData_$reflection()))]);
            }
            catch (ex) {
                return new FSharpResult$2(/* Error */ 1, [ex.message]);
            }
        }, tryReadFileSync(pathJoin([userAppDir, "IssieSettings.json"])))), (_arg.tag === 1) ? ((warn("could not read the saved user settings"), model)) : _arg.fields[0])));
    }
    catch (e) {
        modelOpt = undefined;
    }
    if (modelOpt == null) {
        return [addAppDirToUserData(model), Cmd_none()];
    }
    else {
        return [modelOpt, Cmd_none()];
    }
}

export function writeUserData(model) {
    let option_1, userAppDir, _arg;
    (option_1 = model.UserData.UserAppDir, (option_1 != null) ? some((userAppDir = option_1, (_arg = Result_MapError((mess) => concat("Write error on directory ", userAppDir, ": ", mess), Result_Bind((json) => writeFile(pathJoin([userAppDir, "IssieSettings.json"]), json), (() => {
        try {
            return new FSharpResult$2(/* Ok */ 0, [Convert_serialize(drawBlockModelToUserData(model, model.UserData), createTypeInfo(UserData_$reflection()))]);
        }
        catch (e) {
            return new FSharpResult$2(/* Error */ 1, ["Can\'t write settings on this PC because userAppDir does not exist"]);
        }
    })())), (_arg.tag === 1) ? error(_arg.fields[0]) : undefined))) : undefined);
    return model;
}

/**
 * subfunction used in model update function
 */
export function getSimulationDataOrFail(model, msg) {
    const matchValue = model.CurrentStepSimulationStep;
    if (matchValue != null) {
        const sim = matchValue;
        if (sim.tag === 0) {
            return sim.fields[0];
        }
        else {
            return toFail(printf("what? Getting simulation data when could not start because of error: %s"))(msg);
        }
    }
    else {
        return toFail(printf("what? Getting simulation data when no simulation is running: %s"))(msg);
    }
}

/**
 * handle Menu actions that may need Model data
 */
export function getMenuView(act, model, dispatch) {
    switch (act.tag) {
        case 1: {
            saveOpenFileActionWithModelUpdate(model, dispatch);
            dispatch(new Msg(/* JSDiagramMsg */ 8, [new JSDiagramMsg(/* SetHasUnsavedChanges */ 4, [false])]));
            break;
        }
        case 2: {
            saveOpenProjectInNewFormat(model);
            break;
        }
        case 3: {
            addFileToProject(model, dispatch);
            break;
        }
        case 6: {
            break;
        }
        case 4: {
            doActionWithSaveFileDialog("Exit ISSIE", Msg.CloseApp, model, dispatch, undefined);
            break;
        }
        default:
            undefined;
    }
    return model;
}

/**
 * get timestamp of current loaded component.
 * is this ever used? No.
 */
export function getCurrentTimeStamp(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const p = matchValue;
        const _arg = tryFind((lc) => (lc.Name === p.OpenFileName), p.LoadedComponents);
        if (_arg == null) {
            const arg_1 = map((lc_2) => lc_2.Name, p.LoadedComponents);
            return toFail(printf("Project inconsistency: can\'t find component %s in %A"))(p.OpenFileName)(arg_1);
        }
        else {
            return _arg.TimeStamp;
        }
    }
    else {
        return minValue();
    }
}

/**
 * Replace timestamp of current loaded component in model project by current time
 * Used in update function
 */
export function updateTimeStamp(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const p = matchValue;
        return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, new Project(p.ProjectPath, p.OpenFileName, p.WorkingFileName, map((lc_1) => {
            if (lc_1.Name === p.OpenFileName) {
                const lc = lc_1;
                return new LoadedComponent(lc.Name, now(), lc.FilePath, lc.WaveInfo, lc.CanvasState, lc.InputLabels, lc.OutputLabels, lc.LCParameterSlots, lc.Form, lc.LoadedComponentIsOutOfDate, lc.Description, lc.IsTopSheet, lc.ArrayInfo);
            }
            else {
                return lc_1;
            }
        }, p.LoadedComponents)), model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
    }
    else {
        return model;
    }
}

export const currentSheetIsOutOfDate = currentSheetIsOutOfDate_1;

/**
 * Clear the properties pane's half-typed state when a different component is selected, so that
 * each component's boxes start from what that component is, not from what was being typed into
 * the last one.
 * 
 * DialogState goes with Text and Int: it holds the text and the error of every property box, and
 * a box left mid-edit would otherwise carry its message onto the next component's pane. Its keys
 * name the component, so a stale entry cannot be read by the wrong box - but it can be read again
 * by the SAME component later, showing an edit the user has since abandoned.
 */
export function resetDialogIfSelectionHasChanged(newModel, oldModel) {
    let f, f1_1, f1, f2, f2_1;
    const newSelected = newModel.Sheet.SelectedComponents;
    if ((length(newSelected) === 1) && !equals(newSelected, oldModel.Sheet.SelectedComponents)) {
        return ((f = ((f1_1 = ((f1 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, text_)(undefined), (f2 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, int_)(undefined), (arg_3) => f2(f1(arg_3))))), (f2_1 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, paramCompSpec_)(undefined), (arg_5) => f2_1(f1_1(arg_5))))), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, popupDialogData_)(f)))(newModel);
    }
    else {
        return newModel;
    }
}

export function updateComponentMemory(addr, data, compOpt) {
    let mem_1, ct_1;
    let matchResult, comp, ct, mem;
    if (compOpt != null) {
        switch (compOpt.Type.tag) {
            case 39: {
                matchResult = 1;
                comp = compOpt;
                ct = compOpt.Type;
                mem = compOpt.Type.fields[0];
                break;
            }
            case 40: {
                matchResult = 1;
                comp = compOpt;
                ct = compOpt.Type;
                mem = compOpt.Type.fields[0];
                break;
            }
            case 42: {
                matchResult = 1;
                comp = compOpt;
                ct = compOpt.Type;
                mem = compOpt.Type.fields[0];
                break;
            }
            case 41: {
                matchResult = 1;
                comp = compOpt;
                ct = compOpt.Type;
                mem = compOpt.Type.fields[0];
                break;
            }
            default:
                matchResult = 2;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return undefined;
        case 1:
            return new Component(comp.Id, (mem_1 = (new Memory1(mem.Init, mem.AddressWidth, mem.WordWidth, add_1(addr, data, mem.Data), mem.Comments)), (ct_1 = ct, (ct_1.tag === 39) ? (new ComponentType(/* AsyncROM1 */ 39, [mem_1])) : ((ct_1.tag === 40) ? (new ComponentType(/* ROM1 */ 40, [mem_1])) : ((ct_1.tag === 41) ? (new ComponentType(/* RAM1 */ 41, [mem_1])) : ((ct_1.tag === 42) ? (new ComponentType(/* AsyncRAM1 */ 42, [mem_1])) : ct_1))))), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo);
        default:
            return compOpt;
    }
}

export function exitApp(model) {
    writeUserData(model);
    window.issieBridge.ipc.quit();
}

/**
 * Tests physical equality on two objects.
 * Used because Msg type does not support structural equality.
 * **DANGER** will only work for messages which are physically the the same.
 * In this use case that is fine.
 */
export function isSameMsg() {
    return (e) => ((e_1) => (e === e_1));
}

/**
 * Returns None if no mouse drag message found, returns Some (lastMouseMsg, msgQueueWithoutMouseMsgs) if a drag message was found
 */
export function getLastMouseMsg(msgQueue) {
    const _arg = filter((msg) => matchMouseMsg((op) => equals(op, MouseOp.Drag), msg), msgQueue);
    if (isEmpty(_arg)) {
        return undefined;
    }
    else {
        return head(_arg);
    }
}

export function sheetMsg(sMsg, model) {
    let pairs;
    const patternInput = update_1(sMsg, model);
    const sModel = patternInput[0];
    const model$0027 = new Model(sModel.WindowWidth, sModel.KeyFocusPane, sModel.RunAfterRenderWithSpinner, sModel.UserData, sModel.WaveSim, sModel.WaveSimSheet, sModel.UISheetTrail, sModel.Spinner, sModel.Sheet, sModel.IsLoading, sModel.LastChangeCheckTime, sModel.LastSimulatedCanvasState, sModel.LastDetailedSavedState, sModel.CurrentSelected, sModel.LastSelectedIds, sModel.LastUsedDialogWidth, sModel.SelectedComponent, sModel.CurrentStepSimulationStep, sModel.CurrentTruthTable, sModel.TTConfig, sModel.RightPaneTabVisible, sModel.SimSubTabVisible, sModel.CircuitCheck, sModel.Hilighted, sModel.Clipboard, sModel.LastCreatedComponent, currentSheetIsOutOfDate(sModel), sModel.PendingDragAddition, sModel.DragPlacement, sModel.ProjectBrowser, sModel.TopSheetChoiceDeclined, sModel.ComponentLibraries, sModel.OpenLibrary, sModel.CatalogueSearch, sModel.ArrayCopiesTyped, sModel.SimulateInRenderer, sModel.SidecarSession, sModel.ProbeRead, sModel.SidecarInFlight, sModel.SidecarBuildEndedMs, sModel.SidecarRunEndedMs, sModel.StepRunTarget, sModel.FetchedData, sModel.FetchedStructure, sModel.FailedFetch, sModel.StimulusGeneration, sModel.CurrentViewport, sModel.ViewportChangedAtMs, sModel.WaveScrollSettling, sModel.WaveScrollSerial, sModel.ShowLibrarySheets, sModel.SuppressErrorPopups, sModel.OpenedLibrarySheets, sModel.ReadOnlyBaseline, sModel.CurrentProj, sModel.PopupViewFunc, sModel.SpinnerPayload, sModel.PopupDialogData, sModel.Notifications, sModel.TopMenuOpenState, sModel.SheetMenuPinned, sModel.DividerDragMode, sModel.WaveSimViewerWidth, sModel.ConnsOfSelectedWavesAreHighlighted, sModel.Pending, sModel.UIState, sModel.BuildVisible, sModel.CodeEditorState);
    let patternInput_1;
    const matchValue = model.Sheet.Action;
    const matchValue_1 = model$0027.Sheet.Action;
    let matchResult, previous_2;
    switch (matchValue.tag) {
        case 13: {
            if (matchValue_1.tag === 5) {
                matchResult = 0;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        case 5: {
            switch (matchValue_1.tag) {
                case 5: {
                    if (!(matchValue.tag === 5)) {
                        matchResult = 1;
                        previous_2 = matchValue;
                    }
                    else {
                        matchResult = 3;
                    }
                    break;
                }
                case 11: {
                    matchResult = 2;
                    break;
                }
                default:
                    matchResult = 3;
            }
            break;
        }
        default:
            if (matchValue_1.tag === 5) {
                if (!(matchValue.tag === 5)) {
                    matchResult = 1;
                    previous_2 = matchValue;
                }
                else {
                    matchResult = 3;
                }
            }
            else {
                matchResult = 3;
            }
    }
    switch (matchResult) {
        case 0: {
            patternInput_1 = [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, pendingDragAddition_)(new DragAddition(/* PlacedFromCatalogue */ 0, [model$0027.Sheet.SelectedComponents]))(model$0027), Cmd_none()];
            break;
        }
        case 1: {
            const pending = (sMsg.tag === 2) ? ((sMsg.fields[0].tag === 1) ? (new DragAddition(/* PastedFromClipboard */ 1, [model$0027.Sheet.SelectedComponents])) : undefined) : undefined;
            patternInput_1 = [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, pendingDragAddition_)(pending)(model$0027), Cmd_none()];
            break;
        }
        case 2: {
            let pasteCmd;
            const matchValue_3 = model$0027.PendingDragAddition;
            let matchResult_1, pastedIds;
            if (matchValue_3 != null) {
                if (matchValue_3.tag === 1) {
                    matchResult_1 = 0;
                    pastedIds = matchValue_3.fields[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const sourceIds = getCopiedSymbols(model$0027.Sheet.Wire.Symbol);
                    const matchValue_4 = length(sourceIds) === length(pastedIds);
                    if (matchValue_4) {
                        const msg = new Msg(/* UpdateModel */ 41, [(pairs = zip(sourceIds, pastedIds), (model_1) => copyParamSlotsToPastedComponents(pairs, model_1))]);
                        pasteCmd = singleton((dispatch) => {
                            dispatch(msg);
                        });
                    }
                    else {
                        pasteCmd = Cmd_none();
                    }
                    break;
                }
                default:
                    pasteCmd = Cmd_none();
            }
            patternInput_1 = [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, pendingDragAddition_)(undefined)(model$0027), pasteCmd];
            break;
        }
        default:
            patternInput_1 = [model$0027, Cmd_none()];
    }
    const model$0027$0027 = patternInput_1[0];
    return [equals(model.Sheet.SelectedComponents, model$0027$0027.Sheet.SelectedComponents) ? model$0027$0027 : Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, paramCompSpec_)(popupDialogData_))(undefined)(model$0027$0027), Cmd_batch(ofArray([patternInput[1], patternInput_1[1]]))];
}

export function executePendingMessagesF(n, model) {
    if (n === length(model.Pending)) {
        const _arg = getLastMouseMsg(model.Pending);
        if (_arg != null) {
            const mMsg = _arg;
            if (mMsg.tag === 3) {
                return sheetMsg(mMsg.fields[0], new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, empty(), model.UIState, model.BuildVisible, model.CodeEditorState));
            }
            else {
                return toFail(printf("shouldn\'t happen "));
            }
        }
        else {
            return toFail(printf("shouldn\'t happen"));
        }
    }
    else {
        return [model, Cmd_none()];
    }
}

